import { RouteComponentProps } from '@reach/router';
import ForgottenPasswordForm from 'components/forgottenPasswordForm/ForgottenPasswordForm';
import React from 'react';
import Page from '../components/shared/Page';

export const ForgottenPassword: React.FC<RouteComponentProps> = () => {
  return (
    <Page isPublic>
      <div className="ForgottenPasswordPage">
        <div className="Content HeightContent">
          <ForgottenPasswordForm />
        </div>
      </div>
    </Page>
  );
};
